import React, { ReactNode } from 'react';
import { Text, Box, Link, Flex, Grid } from '@keyslabor/shared/ui';
import { Employee } from '@/containers/HoursByDay/types';
import { ColumnHandlers } from './types';
import { DeleteIcon } from '@keyslabor/shared/assets/svgComponents';
import { format } from 'date-fns';

export function headerTitle(title: ReactNode, color?: string) {
  if (color) {
    return (
      <Box
        p="0 26px"
        borderRadius="5px"
        borderWidth="1px"
        borderRight="1px"
        borderStyle="solid"
        borderColor={color}
      >
        <Text
          fontWeight="600"
          fontSize="14px"
          css={`
            @media only screen and (max-width: 1130px) {
              font-size: 16px;
            }
          `}
        >
          {title}
        </Text>
      </Box>
    );
  }

  return (
    <Box border-inline-end="1px solid red">
      <Text fontWeight="500" fontSize="14px">
        {title}
      </Text>
    </Box>
  );
}

export function emptyHeaderTitle() {
  return <Box p="0 26px" borderRadius="5px"></Box>;
}

export function nameColumn(name: string, isBreakpoint: boolean) {
  return (
    <Flex
      width={isBreakpoint ? '100%' : '100%'}
      textAlign={isBreakpoint ? 'left' : 'center'}
      justifyContent={isBreakpoint ? 'flex-start' : 'center'}
    >
      <Text
        fontSize="14px"
        fontWeight="400"
        maxChars={31}
        maxWidth="200px"
        css={`
          word-spacing: ${isBreakpoint ? '200px' : '1px'};
        `}
      >
        {name}
      </Text>
    </Flex>
  );
}

export function createdByColumn(data: Employee) {
  const { name } = data;
  return (
    <Text fontSize="14px" fontWeight="400" noWrap maxWidth="200px">
      {name}
    </Text>
  );
}

export function DateColumn(date: string, isMobile: boolean) {
  if (isMobile) {
    return (
      <Grid gridAutoColumns={'max-content max-content'}>
        <Text fontSize="14px" fontWeight="400">
          {format(new Date(date), 'MM/dd')}
        </Text>
        <Text fontSize="14px" fontWeight="400" mt="5px">
          {format(new Date(date), 'yyyy')}
        </Text>
      </Grid>
    );
  }

  return (
    <Text fontSize="14px" fontWeight="400">
      {format(new Date(date), 'MM/dd/yyyy')}
    </Text>
  );
}

export function deleteColumn(handlers: ColumnHandlers) {
  // eslint-disable-next-line react/display-name
  return function (id: number, rest) {
    return (
      <>
        {rest.is_paid ? (
          <Text color="green" fontWeight="400">
            Paid
          </Text>
        ) : (
          <Link kind="icon" onClick={() => handlers.onDelete(id)}>
            <DeleteIcon />
          </Link>
        )}
      </>
    );
  };
}
